
import { useState, useEffect } from 'react';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', href: '#hero' },
    { name: 'Entry Tunnel', href: '#entry-food-tunnel' },
    // { name: 'Sustainable Living', href: '#sustainable-living' },
    { name: 'Renewable Energy', href: '#renewable-energy' },
    // { name: 'Heritage', href: '#heritage' },
    { name: 'Pick Your Own', href: '#pick-your-own' },
    // { name: 'Be a Farmer', href: '#be-a-farmer' },
    { name: 'Rose Garden', href: '#rose-garden' },
    // { name: 'Tamil Culture', href: '#tamil-culture' },
    { name: 'Permaculture', href: '#permaculture' },
    { name: 'Square Inch Farming', href: '#square-inch-farming' },
    { name: 'Modern Farming', href: '#modern-farming' },
    { name: 'Protected Cultivation', href: '#protected-cultivation' },
    // { name: 'Interact with Farmers', href: '#interact-farmers' },
    // { name: 'Boutique', href: '#boutique' },
    // { name: 'Fishing', href: '#fishing' },
    { name: 'Native & Natural', href: '#native-natural' }
  ];

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
    }`}>
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14 sm:h-16">
          {/* Logo */}
          <div className="flex-shrink-0 min-w-0">
            <span 
              className={`text-lg sm:text-xl lg:text-2xl font-bold transition-colors duration-300 cursor-pointer truncate ${
                isScrolled ? 'text-green-600' : 'text-white'
              }`}
              style={{ fontFamily: 'Pacifico, serif' }}
              onClick={() => scrollToSection('#hero')}
            >
              Aroha Farm
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:block">
            <div className="ml-4 xl:ml-10 flex items-baseline space-x-2 xl:space-x-4">
              {navItems.slice(0, 8).map((item) => (
                <button
                  key={item.name}
                  onClick={() => scrollToSection(item.href)}
                  className={`px-2 xl:px-3 py-2 rounded-md text-xs xl:text-sm font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                    isScrolled 
                      ? 'text-gray-700 hover:text-green-600 hover:bg-green-50' 
                      : 'text-white hover:text-green-300 hover:bg-white/10'
                  }`}
                >
                  {item.name}
                </button>
              ))}
              
              {/* More Dropdown */}
              <div className="relative group">
                <button className={`px-2 xl:px-3 py-2 rounded-md text-xs xl:text-sm font-medium transition-colors duration-300 cursor-pointer flex items-center ${
                  isScrolled 
                    ? 'text-gray-700 hover:text-green-600 hover:bg-green-50' 
                    : 'text-white hover:text-green-300 hover:bg-white/10'
                }`}>
                  More
                  <i className="ri-arrow-down-s-line ml-1"></i>
                </button>
                
                <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
                  <div className="py-1">
                    {navItems.slice(8).map((item) => (
                      <button
                        key={item.name}
                        onClick={() => scrollToSection(item.href)}
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 cursor-pointer"
                      >
                        {item.name}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className={`inline-flex items-center justify-center p-2 rounded-md transition-colors duration-300 cursor-pointer ${
                isScrolled 
                  ? 'text-gray-700 hover:text-green-600 hover:bg-green-50' 
                  : 'text-white hover:text-green-300 hover:bg-white/10'
              }`}
            >
              <i className={`text-xl ${isOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className={`lg:hidden transition-all duration-300 ${
        isOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
      } overflow-hidden bg-white/95 backdrop-blur-md`}>
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 max-h-80 overflow-y-auto">
          {navItems.map((item) => (
            <button
              key={item.name}
              onClick={() => scrollToSection(item.href)}
              className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-green-50 cursor-pointer"
            >
              {item.name}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
